// Простая система событий для мерчантов
class MerchantEventEmitter {
    private events: { [key: string]: Function[] } = {};

    on(event: string, callback: Function) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }

    off(event: string, callback: Function) {
        if (!this.events[event]) return;
        this.events[event] = this.events[event].filter(cb => cb !== callback);
    }

    emit(event: string, ...args: any[]) {
        if (!this.events[event]) return;
        this.events[event].forEach(callback => callback(...args));
    }
}

export const merchantEvents = new MerchantEventEmitter();

export const MERCHANT_EVENTS = {
    PAYMENT_CREATED: 'payment_created',
    PAYMENT_STATUS_CHANGED: 'payment_status_changed',
    STATS_UPDATED: 'stats_updated',
} as const;
